import { render, staticRenderFns } from "./WarningInfo.vue?vue&type=template&id=8791a55e&scoped=true"
import script from "./WarningInfo.vue?vue&type=script&lang=js"
export * from "./WarningInfo.vue?vue&type=script&lang=js"
import style0 from "./WarningInfo.vue?vue&type=style&index=0&id=8791a55e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8791a55e",
  null
  
)

export default component.exports